import { HttpError } from '@luminovo/api-contracts';
import { httpQuery } from '@luminovo/data-stack';
import { createFileRoute, notFound } from '@tanstack/react-router';

import { QuoteRequestDetailsPage } from '@/areas/quote-requests/QuoteRequests/QuoteRequestDetailsPage/QuoteRequestDetailsPage';
import type { PageStaticData } from '@/shared/routing';

// The page shows the quote request in the negotiation's sidebar, and its links lead within the negotiation. A quote
// request of another negotiation, or one the API doesn't know (it answers 404), renders the not-found page: a link
// never leads there, a hand-edited URL does. The loader asks for it with the query the page reads it with.
export const Route = createFileRoute(
    '/_authenticated/next/negotiations/$negotiationId/_sidebar/quote-requests/$quoteRequestId',
)({
    staticData: { access: { permissions: ['view:sourcing'] }, chrome: 'none' } satisfies PageStaticData,
    loader: async ({ context: { queryClient }, params: { negotiationId, quoteRequestId } }) => {
        const { project } = await queryClient
            .ensureQueryData(httpQuery('GET /quote-request/:id', { pathParams: { id: quoteRequestId } }))
            .catch((error: unknown) => {
                throw error instanceof HttpError && error.status === 404 ? notFound() : error;
            });
        if (project?.type !== 'NegotiationV2' || project.id !== negotiationId) {
            throw notFound();
        }
    },
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { negotiationId, quoteRequestId } = Route.useParams();
    return (
        <QuoteRequestDetailsPage
            context={{ type: 'NegotiationV2', id: negotiationId }}
            quoteRequestId={quoteRequestId}
        />
    );
}
